export default {
	headers: {
		general: {
			patient: "Paciente",
			options: "Opções",
			attach: "Anexar",
			alert_history: "Histórico de alertas",
			resume: "Resumo",
			readings: "Leituras",
			notifications: "Notificações",
			report: "Relatório",
			reports: "Relatórios",
			attach_device: "Anexar dispositivo",
			reading: "Leitura",
			position: "Posição",
			zone: "Zona",
			pillbox: "Caixa do comprimido",
			add_pill: "Adicionar comprimido",
			edit_pill: "Editar comprimido",
			healthreports: "Relatórios de saúde",
			medicaldocuments: "Documentos médicos",
			edit_configs: "Editar configurações",
			history: "Histórico",
			response: "Resposta",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/headers/headers_pt.js